import { render, staticRenderFns } from "./avisolegal.vue?vue&type=template&id=f02970ec&"
import script from "./avisolegal.vue?vue&type=script&lang=js&"
export * from "./avisolegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports